import React, { memo } from 'react';

import MyModal from 'v2/components/Shared/MyModal';

interface IProps {
  opened: boolean;
  onClose: () => void;
}

const ModalMinor = memo(({ opened, onClose }: IProps) => {
  if (!opened) {
    return null;
  }

  return (
    <MyModal opened={opened} onClose={onClose} buttonCancel='Fechar' showOk={false} submitDisabled={false}>
      <div>
        O acesso e cadastro na Plataforma é totalmente gratuito. Porém, os serviços oferecidos podem ser contratados
        SOMENTE por pessoas maiores de 18 anos de idade, capazes de responder por todos os seus atos. Ou seja, pessoas
        menores de idade não poderão se cadastrar na Plataforma da Eduzz.
      </div>
    </MyModal>
  );
});

export default ModalMinor;
